import clsx from 'clsx'
import { ChevronDown } from 'lucide-react'
import { useState } from 'react'

import { AWXConnectedAccountStatus, type AwxConnectedAccount } from '@ankor-io/common/types/awx'

import { useConnectedAccount } from '@/providers/connectedAccount'
import { useUserContext } from '@/providers/user/useUserContext'
import { Badge } from '@/ui-components/Badge'
import { Dropdown, DropdownButton, DropdownDivider, DropdownItem, DropdownMenu } from '@/ui-components/Dropdown'
import Loading from '@/ui-components/Loading'

import NewConnectedAccountModal from './NewConnectedAccountModal/NewConnectedAccountModal'

export const ConnectedAccountsDropdown = () => {
  const [isAccountModalOpen, setIsAccountModalOpen] = useState(false)
  const { connectedAccounts, isLoading } = useConnectedAccount()
  const { activeConnectedAccountId, updateActiveConnectedAccountId } = useUserContext()

  const selectedConnectedAccount =
    connectedAccounts.find((acct) => acct.id === activeConnectedAccountId) || connectedAccounts[0] || null

  const handleDropdownItemClick = (connectedAccount: AwxConnectedAccount) => {
    updateActiveConnectedAccountId(connectedAccount.id)
  }

  return (
    <div className="relative">
      <Dropdown>
        <DropdownButton
          outline
          className="w-full flex items-center justify-between px-3 py-2 rounded-lg border"
        >
          <span className="w-full text-left text-gray-900 dark:text-white">
            {isLoading ? <Loading /> : selectedConnectedAccount?.name || 'Select Vessel'}
          </span>
          <ChevronDown className="ml-2 size-4" />
        </DropdownButton>
        <DropdownMenu anchor="bottom start">
          {connectedAccounts.map((acct) => (
            <DropdownItem
              key={acct.id}
              to="/"
              onClick={() => handleDropdownItemClick(acct)}
              className={clsx(
                acct.id === selectedConnectedAccount?.id &&
                  'bg-primary-500/10 dark:bg-primary-500/10 hover:data-focus:bg-primary-500/10 dark:hover:data-focus:bg-primary-500/10 select-none cursor-none',
              )}
            >
              <span
                className={clsx(
                  acct.id === selectedConnectedAccount?.id && 'font-bold text-primary-500 dark:text-primary-400',
                )}
              >
                {acct.name}
              </span>

              {acct.status !== AWXConnectedAccountStatus.ACTIVE && (
                <span className="col-span-3">
                  <Badge color="amber">Pending</Badge>
                </span>
              )}
            </DropdownItem>
          ))}
          {connectedAccounts.length > 0 && <DropdownDivider />}
          <DropdownItem
            onClick={() => setIsAccountModalOpen(true)}
            className="justify-center text-primary-600 dark:text-primary-300 font-medium"
          >
            + Create new Vessel
          </DropdownItem>
        </DropdownMenu>
      </Dropdown>
      <NewConnectedAccountModal
        setIsOpen={setIsAccountModalOpen}
        isOpen={isAccountModalOpen}
      />
    </div>
  )
}

export default ConnectedAccountsDropdown
